// extracted by mini-css-extract-plugin
module.exports = {"collection":"ConsentsCollection_collection__gVxtS","item":"ConsentsCollection_item__2QYom","header":"ConsentsCollection_header__3ooWy"};